import React, {Component} from 'react';
import {
  Dimmer,
  Loader,
} from 'semantic-ui-react';
import PropTypes from 'prop-types';

// Controller
import globalController from '../../global/globalcontroller';

// Style
import './MainLoading.scss';

const propTypes = {isLoadingTemplates: PropTypes.bool};

const defaultProps = {isLoadingTemplates: false};

class MainLoading extends Component {

  render() {
    const {isLoadingTemplates} = this.props;

    if (isLoadingTemplates) {
      return (
        <div className='mainLoading'>
          <Dimmer active>
            <Loader size='huge'>{'Loading'}</Loader>
          </Dimmer>
        </div>
      );
    }

    return null;
  }

}

MainLoading.propTypes = propTypes;

MainLoading.defaultProps = defaultProps;

export default globalController(MainLoading);



// WEBPACK FOOTER //
// ./src/organisms/MainLoading/MainLoading.js